import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

export function PartnersSlider() {
    let isAuto = $('.partners-slider').attr('data-slideAuto');
    // convert isAuto to boolean
    isAuto = (String(isAuto).toLowerCase() === 'true');

    if(isAuto) {
        new Swiper(".partners-slider", {
            loop: true,
            freeMode: true,
            allowTouchMove: false,
            speed: 5000,
            freeModeMomentum: false,
            autoplay: {
                delay: 1,
                disableOnInteraction: false
            },
            breakpoints: {
                320: {
                    slidesPerView: 2,
                },
                640: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
                991: {
                    slidesPerView: 4,
                },
                1199: {
                    slidesPerView: 5,
                },
            },
        });
    } else {
        new Swiper(".partners-slider", {
            loop: true,
            freeMode: true,
            allowTouchMove: false,
            speed: 300,
            freeModeMomentum: false,
            breakpoints: {
                320: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                640: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                768: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
                991: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                },
                1199: {
                    slidesPerView: 5,
                    slidesPerGroup: 5,
                },
            },
            navigation: {
                nextEl: '.partner-slider-right',
                prevEl: '.partner-slider-left'
            }
        });
    }
}

